import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import DashboardLayout from '../layouts/dashboard';
//import IndividualStudentActions from '../sections/exam_submissions/view/individual-student-actions';
//import Students from '../sections/students/view/user-view';
//export const Students = lazy(() => import('../sections/stude/nts/view/user-view'));
export const IndexPage = lazy(() => import('../pages/app'));
//export const AddOrganizationPage  =  lazy(()=> import('../pages/Add-Organization'))
export const ExamPage = lazy(() => import('../pages/exams'));
export const ExamResultPage = lazy(() => import('../pages/exam-result'));
export const QuestionPage = lazy(() => import('../pages/questions'));
export const SubmissionPage = lazy(() => import('../pages/submissions'));
export const AddExamPage  =  lazy(()=> import('../pages/Add-Exam'))
export const AddQuestionPage  =  lazy(()=> import('../pages/Add-Question'))
export const Students = lazy(() => import('../pages/students'));
export const Courses = lazy(() => import('../pages/courses'));
export const AddCoursePage  =  lazy(()=> import('../pages/Add-Course'))
export const EditCoursePage  =  lazy(()=> import('../pages/Edit-Course'))
export const AddStudentPage  =  lazy(()=> import('../pages/Add-Student'))
export const ImportStudentsPage  =  lazy(()=> import('../pages/Import-Students'))
export const EditStudentPage  =  lazy(()=> import('../pages/Edit-Student'))
export const EditExamPage  =  lazy(()=> import('../pages/Edit-Exam'))
export const CloneExamPage  =  lazy(()=> import('../pages/Clone-Exam'))
export const EditQuestionPage  =  lazy(()=> import('../pages/Edit-Question'))
export const StudentActions  =  lazy(()=> import('../pages/Student-Actions'))
export const IndividualStudentActions  =  lazy(()=> import('../pages/Individual-Student-Actions'))
//export const UserPage = lazy(() => import('../pages/user'));
//export const LoginPage = lazy(() => import('../pages/login'));
export const Page404 = lazy(() => import('../pages/page-not-found'));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      element: (
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        { element: <IndexPage />, index: true },
        { path: 'exam', element: <ExamPage /> },
        { path: 'add-exam', element: <AddExamPage /> },
        { path: 'edit-exam/:id', element: <EditExamPage/> },
        { path: 'clone-exam/:id', element: <CloneExamPage/> },
        { path: 'exam-result', element: <ExamResultPage/> },
        { path: 'question/:e_id', element: <QuestionPage /> },
        { path: 'submissions/:course_id/:e_id', element: <SubmissionPage /> },
        { path: 'add-question', element: <AddQuestionPage /> },
        { path: 'add-student', element: <AddStudentPage /> },
        { path: 'import-students', element: <ImportStudentsPage /> },
        { path: 'student', element: <Students/> },
        { path: 'course', element: <Courses/> },
        { path: 'student-actions', element: <StudentActions/> },
        { path: 'individual-student-actions', element: <IndividualStudentActions/> },
        { path: 'add-course', element: <AddCoursePage /> },
        { path: 'edit-course/:course_id', element: <EditCoursePage /> },
        { path: 'edit-student/:student_id', element: <EditStudentPage/> },
        { path: 'edit-question/:exam_id/:question_id', element: <EditQuestionPage/> },
        
      ],
    },
    // {
    //   path: 'login',  
    //   element: <LoginPage />,
    // },
    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
